<template>
  <v-container fluid class="menu">
    <v-row>
      <div v-show="this.isshowMenu" class="conten-nav">
        <div class="option">
          <!-- <router-link class="links" to="/" tag="button"> -->
          <v-btn
            class="btn-option"
            :class="{ active: this.menu == 1 }"
            @click="goto360view()"
          >
            360° Views
          </v-btn>
          <!-- </router-link> -->

          <!-- <router-link class="links" to="floorplans" tag="button"> -->
          <v-btn
            class="btn-option"
            :class="{ active: this.menu == 2 }"
            @click="gotofloorplans()"
          >
            Floor plans
          </v-btn>
          <!-- </router-link> -->

          <!-- <router-link class="links " to="/location" tag="button"> -->
          <v-btn
            class="btn-option"
            :class="{ active: this.menu == 3 }"
            @click="gotolocation()"
          >
            Location Map
          </v-btn>

             <!-- <router-link class="links" to="/" tag="button"> -->
          <v-btn class="btn-option " @click="showQL()"> Facilities </v-btn>
          <!-- </router-link> -->
          <!-- </router-link> -->
          <v-btn
            class="btn-option last"
            @click="from()"
            v-bind:class="{ active: this.isshowQL }"
          >
            Registration
          </v-btn>
       
          <!-- <router-link to="laM" tag="ui-button" class="btn-option">
                Location Map
              </router-link> -->
          <v-btn @click="ismusic()" class="btn-music">
            <img
              v-show="this.musicz2"
              class="img-music"
              src="../assets/1x/musicon.png"
            />
            <img
              v-show="!this.musicz2"
              class="img-music"
              src="../assets/1x/musicoff.png"
            />
          </v-btn>
        </div>
      </div>
    </v-row>
    <div class="nav">
      <v-btn
        @click="showMenu()"
        class="btn-nav"
        :class="{ active: this.isshowMenu }"
      >
        <!-- @mouseover="isNar =! isNar" @mouseout="isNar =! isNar" -->
        <img
          v-show="this.isshowMenu"
          width="27"
          class="icon-show"
          src="../assets/iconNar.png"
        />
        <img
          v-show="!this.isshowMenu"
          width="27"
          class="icon-show"
          src="../assets/iconNarb.png"
        />
      </v-btn>
    </div>
    <div class="bg_prot">
      <div id="prot">Please turn on Auto-rotate mode and rotate your device!</div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
var audio = new Audio(require("../assets/IntheMomentofInspiration.mp3"));
export default {
  data() {
    return {
      // isShow: false,
      isNar: true,
      // isShowQL: false,

      // menu: this.$store.state.menu,
    };
  },
  computed: {
    ...mapGetters(["menu", "isshowMenu", "musicz", "musicz2"]),
  },
  methods: {
    ...mapMutations([
      "setisShowQL",
      "setisShowMenu",
      "setMenu",
      "setMusicz",
      "setRender",
      "setMusicz2",
    ]),
    ismusic() {
      if (this.musicz2 == true) {
        this.setMusicz2(false);
        // this.setMusicz(false)
        audio.pause();
      } else {
        // this.setMusicz(true)
        this.setMusicz2(true);
        audio.play();
      }
    },

    showMenu() {
      if (this.isshowMenu == true) {
        this.setisShowMenu(false);
      } else {
        this.setisShowMenu(true);
      }
    },
    from() {
      window.location.href = "https://paradisoplace.com.au/#enquire";
    },
    showQL() {
      this.setisShowQL(true);
      this.setisShowMenu(false);
      this.goto360view();
    },
    gotohome() {
      this.$router.push("/");
      // this.isShowQL = true
    },
    ...mapMutations(["setMenu"]),
    gotoview(a) {
      this.loadPanoById(a, true);
    },

    gotofloorplans() {
      this.setMenu(2);
      this.setisShowMenu(false);
      this.$router.push("/floorplans");
    },
    gotolocation() {
      this.setMenu(3);
      this.setisShowMenu(false);
      this.$router.push("/location");
    },
    goto360view() {
      this.setMenu(1);
      this.setisShowMenu(false);
      this.setRender(false);
      this.$router.push("/");
      if (this.musicz2 == true) {
        this.setMusicz2(false);
        this.setMusicz(true);
        audio.pause();
      }
    },
  },
  mounted() {
    if (this.musicz2 == true && this.musicz == false) {
      audio.play();
    }
  },
};
</script>

<style scoped>
</style>